export const mbcBulkAssignModule = 'mbcBulkAssign';
